import { render, staticRenderFns } from "./purchaselog.vue?vue&type=template&id=b906703c&scoped=true"
import script from "./purchaselog.vue?vue&type=script&lang=js"
export * from "./purchaselog.vue?vue&type=script&lang=js"
import style0 from "./purchaselog.vue?vue&type=style&index=0&id=b906703c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b906703c",
  null
  
)

export default component.exports